// extracted by mini-css-extract-plugin
export default {"_link":"Header__link__IRrfd","dropdowntitle":"Header_dropdowntitle__cVIvb","_dropdownitem":"Header__dropdownitem__xhPPr","_brand":"Header__brand__nssCr"};